<template>
    <div>
        <LoadingPage v-if="isLoadPage" />
        <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
        <!-- Card stats -->
        <b-row> </b-row>
        </base-header>
        <b-container fluid class="mt--7">
            <b-col lg="12">
                <card header-classes="bg-transparent">
                    <b-row class="mb-4">
                        <b-col lg="9" xl="10" md="12" class="d-flex flex-column mb-4">
                            <h2 slot="header" class="mb-0">จัดการประเภทรถ</h2>
                            <div class="text-body-1">
                                แสดงตารางรายละเอียดประเภทรถทั้งหมดที่มีอยู่
                            </div>
                        </b-col>
                        <b-col lg="3" xl="2" md="12" class="text-right">
                            <base-button type="primary" class="d-flex align-items-center" block @click="openModalCategoryCar()">
                                <b-icon icon="plus" class="mr-2"></b-icon> เพิ่มประเภทรถ
                            </base-button>
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-end">
                        <b-col lg="4" md="12" class="mb-2">
                            <b-form-input
                                v-model="searchTerm"
                                placeholder="ค้นหาด้วยชื่อประเภทรถ"
                                @input="onSearchInput"
                            >
                            </b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col>
                            <b-table
                                responsive
                                :fields="fields"
                                :items="categoryCars"
                                :busy="isLoading"
                            >
                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    </div>
                                </template>
                                <template #cell(index)="data">
                                    {{
                                    calculateIndex(
                                        data,
                                        pagination.currentPage,
                                        pagination.perPage
                                    )
                                    }}
                                </template>
                                <template #cell(name)="data">
                                   {{data.item.name}}
                                </template>
                                <template #cell(manage)="data">
                                    <b-button
                                        variant="outline-border"
                                        size="sm"
                                        @click="
                                           setFormatDialog(data.item)
                                        "
                                    >
                                        <b-icon icon="pencil-square"></b-icon>
                                    </b-button>
                                    <b-button variant="outline-danger" size="sm" @click="openModalConfirm(data.item.id)">
                                        <b-icon icon="trash-fill"></b-icon>
                                    </b-button>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="d-flex justify-content-end">
                            <b-pagination
                                v-model="pagination.currentPage"
                                :disabled="isLoading"
                                :total-rows="pagination.totalRows"
                                :per-page="pagination.perPage"
                                aria-controls="my-table"
                                class="mt-3"
                                @change="(page) => getCategoryCar(page)"
                            ></b-pagination>
                        </b-col>
                    </b-row>
                </card>
            </b-col>
            <ModalCategoryCar 
                :form="form" 
                @getCategoryCar="getCategoryCar"
            />
            <ModalConfirm
                ref="confirmDelete"
                :confirm="confirm"
                @confirmModal="onDeleteCategoryCar"
            /> 
        </b-container>
    </div>
</template>

<script>
import ModalCategoryCar from "@/components/Car/ModalCategoryCar.vue"
import categoryCarServices from "@/api/category-car.service.js";
import ModalConfirm from "@/components/Modal/Alert/ModalConfirm.vue";
import createDebouncedFunction from "@/util/debounce.js";
import { getCancelToken } from "@/util/axiosCancel";
import calculateIndex from "@/util/calculateIndex.js";

export default {
    components: {
        ModalConfirm, 
        ModalCategoryCar 
    },
    data() {
        return {
            isLoadPage: false,
            isLoading: false,
            calculateIndex,
            pagination: {
                currentPage: 1,
                perPage: 10,
                totalRows: 0,
            },
            searchTerm: "",
            categoryCars: [],
            fields: [
                {
                    key: "index",
                    label: "#",
                },
                {
                    key: "name",
                    label: "ประเภทรถ",
                },
                {
                    key: "temperature_type",
                    label: "ประเภทอุณหภูมิ",
                },
                {
                    key: "degrees",
                    label: "อุณหภูมิ",
                },
                {
                    key: "manage",
                    label: "การจัดการ",
                },
            ],
            confirm: {
                show: false,
                icon: '<i class="fas fa-times-circle text-red fa-5x"></i>',
                emphasize: "ต้องการลบรายการ",
                text: "กรุณาตรวจสอบข้อมูล หากลบรายการแล้วจะไม่สามารถกู้คืนได้",
                isLoad: false,
                id: null
            },
            form: {
                show: false,
                isLoad: false,
                categoryCar: {
                    id: null,
                    name: null,
                    typeTemperature: null,
                    temperature: null
                }
            }
        }
    },
    created() {
        this.getCategoryCar();
    },
    methods: {
        onSearchInput: createDebouncedFunction(function() {
            this.getCategoryCar();
        }, 500),
        async getCategoryCar(page = 1) {
            this.isLoading = true;
            this.isLoadPage = true
            try {
                const cancelToken = getCancelToken();
                const response = await categoryCarServices.getCategoryCar({
                        page,
                        filters: this.searchTerm,
                    },
                    cancelToken
                );

                this.categoryCars = response.data.data.items;
                this.pagination.totalRows = response.data.data.meta.totalItems;
                this.pagination.perPage = response.data.data.meta.itemsPerPage;
                this.pagination.currentPage = response.data.data.meta.currentPage;

            } catch (error) {
                console.log(error);
            } finally {
                this.isLoading = false;
                this.isLoadPage = false
            }
        },
        async onDeleteCategoryCar(){
            try{
                this.isLoadPage = true; 
                await categoryCarServices.removeCategoryCar(this.confirm.id)
                this.getCategoryCar();
                this.$refs.confirmDelete.closeModalConfirm();
            }catch (error) {}
            finally { this.isLoadPage = false }
        },
        setFormatDialog(item){
            this.form.categoryCar = {
                id: item.id,
                name: item.name,
                typeTemperature: item.temperature_type,
                temperature: item.degrees
            }

            this.openModalCategoryCar();
        },
        openModalCategoryCar(){
            this.form.show = true
        },
        openModalConfirm(userId){
            this.confirm.show = true
            this.confirm.id = userId
            this.confirm.icon = '<i class="fas fa-times-circle text-red fa-5x"></i>';
            this.confirm.emphasize = "ต้องการลบรายการ";
            this.confirm.text = "กรุณาตรวจสอบข้อมูล หากลบรายการแล้วจะไม่สามารถกู้คืนได้";
        },
    },
}
</script>
